<template>
  <span v-html="highlightedText" />
</template>

<script setup lang="ts">
const props = defineProps<{
  query: string
  text: string
}>();

const { query, text } = toRefs(props);
const highlightedText = computed(() => {
  return text.value.replace(new RegExp(`(${escapeRegExp(query.value)})`, 'gi'), '<span class="highlight">$1</span>');
});
</script>

<style scoped lang="scss">
@import '~/assets/styles/variables';

:deep(.highlight) {
  display: inline-block;
  background-color: color-mix(in srgb, $primary, transparent 75%);
}
</style>
